if (!customElements.get('mm-package-form')) {
  customElements.define('mm-package-form', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.form = this.querySelector('form');
      this.variants = JSON.parse(this.querySelector('[data-package-variants]').textContent);
      this.count = Number(this.dataset.count);
      this.button = this.querySelector('button[type="submit"]');
      this.form.addEventListener('input', () => this.refresh());
      this.form.addEventListener('change', () => this.refresh());
      this.form.addEventListener('submit', event => this.submit(event));
      this.refresh();
    }
    refresh() {
      const quantities = [...this.querySelectorAll('[data-size]')].map(input => Number(input.value));
      const total = quantities.reduce((sum, number) => sum + number, 0);
      const validSizes = quantities.every(number => Number.isInteger(number) && number >= 0 && number <= this.count) && total === this.count;
      const color = this.querySelector('[data-color]').value;
      const front = this.querySelector('[data-front]')?.value;
      const options = this.count === 12 ? [color, front, String(quantities[4])] : [color, String(quantities[4])];
      this.variant = this.variants.find(variant => variant.options.every((option, i) => option === options[i]));
      this.form.elements.id.value = this.variant?.id || '';
      const money = this.variant ? new Intl.NumberFormat('en-US', {style:'currency', currency:'USD'}).format(this.variant.price / 100) : '—';
      this.querySelector('[data-summary]').textContent = `${total} ${this.dataset.countWord} ${this.count} ${this.dataset.selected} · ${this.dataset.total}: ${money}`;
      const uploading = this.querySelector('[data-art-method]').value === 'Upload with order';
      this.querySelector('[data-upload-fields]').hidden = !uploading;
      this.querySelector('[data-email-help]').hidden = uploading;
      this.querySelectorAll('input[type="file"]').forEach(input => { input.disabled = !uploading; });
      this.querySelector('[data-front-file]').required = uploading;
      this.button.disabled = !validSizes || !this.variant?.available || this.busy;
      this.querySelector('[data-error]').textContent = '';
      return validSizes;
    }
    async submit(event) {
      event.preventDefault();
      if (this.busy) return;
      if (!this.refresh() || !this.form.reportValidity()) return;
      const error = this.querySelector('[data-error]');
      if (!this.variant?.available) { error.textContent = this.dataset.unavailable; return; }
      const files = [...this.querySelectorAll('input[type="file"]:not(:disabled)')].flatMap(input => [...input.files]);
      if (files.reduce((sum,file) => sum + file.size, 0) > 10 * 1024 * 1024) { error.textContent = this.dataset.fileError; return; }
      this.busy = true;
      this.button.disabled = true;
      this.button.textContent = this.dataset.busy;
      try {
        const data = new FormData(this.form);
        const response = await fetch(this.form.action + '.js', {method:'POST',body:data,headers:{Accept:'application/json'}});
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || this.dataset.error);
        window.location.assign(this.form.action.replace(/\/add$/, ''));
      } catch (failure) {
        this.busy = false;
        this.refresh();
        error.textContent = failure.message || this.dataset.error;
        this.button.textContent = this.dataset.submit;
      }
    }
  });
}
